// extracted by mini-css-extract-plugin
export default {"RIGHT":"ArrowIcon_RIGHT__FvZiY","DOWN":"ArrowIcon_DOWN__jvyE6","UP":"ArrowIcon_UP__XAh3p"};